import React from 'react'
import { ShortDateTime } from '~modules/format/date'
import { Icon } from '~ui'

export default function BookmarksItemReminder({ reminder }) {
    if (reminder?.date)
        return (
            <div className={'ui-bm-reminder'}>
                <Icon name='reminder' size='micro' />
                {' '}
                <ShortDateTime date={reminder.date} />
            </div>
        )

    return null
}